<div
    echarts
    class="chart"
    *ngIf="chartOptions$ | async as chartOptions"
    [options]="chartOptions"
    >
</div>
